import { render, staticRenderFns } from "./feed-gallery.vue?vue&type=template&id=cfebba96&scoped=true&"
import script from "./feed-gallery.vue?vue&type=script&lang=js&"
export * from "./feed-gallery.vue?vue&type=script&lang=js&"
import style0 from "./feed-gallery.vue?vue&type=style&index=0&id=cfebba96&prod&lang=scss&"
import style1 from "./feed-gallery.vue?vue&type=style&index=1&id=cfebba96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfebba96",
  null
  
)

export default component.exports